<template>
  <div class="flex flex-row shadow-md gap-2 rounded-xl mb-4 bg-white p-1">
    <button class="subtab active" @click="go('events/1')">
      {{ t("events.list.list") }}
    </button>
    <button class="subtab inactive">
      {{ t("events.detail.detail") }}</button
    ><button class="subtab inactive">
      {{ t("events.edit.edit") }}
    </button>
  </div>
  <div v-if="!isLoading">
    <div class="flex flex-col gap-2">
      <h1 class="font-extrabold text-2xl">{{ t("events.list.title") }}</h1>
      <div class="text-light-gray text-sm">
        {{ t("events.list.subTitle") }}
      </div>
    </div>
    <div class="grid grid-cols-6 gap-3 my-4">
      <InfoBox
        :title="EventState.events[0].getLocalization()"
        :value="eventsGeneralInformation!.numberOfNotStartedEvents"
        :backgroundColor="EventState.events[0].lightColor"
        :textColor="EventState.events[0].color"
        :call-back="() => applyFilterState(EventState.events[0])"
      >
        <IconManager
          name="Calendar"
          :style="{ color: EventState.events[0].color }"
        />
      </InfoBox>

      <InfoBox
        :title="EventState.events[1].getLocalization()"
        :value="eventsGeneralInformation!.numberOfInPreparation"
        :backgroundColor="EventState.events[1].lightColor"
        :textColor="EventState.events[1].color"
        :call-back="() => applyFilterState(EventState.events[1])"
      >
        <IconManager
          name="Search"
          :style="{ color: EventState.events[1].color }"
        />
      </InfoBox>

      <InfoBox
        :title="EventState.events[2].getLocalization()"
        :value="eventsGeneralInformation!.numberOfPrepared"
        :backgroundColor="EventState.events[2].lightColor"
        :textColor="EventState.events[2].color"
        :call-back="() => applyFilterState(EventState.events[2])"
      >
        <IconManager
          name="Clock"
          :style="{ color: EventState.events[2].color }"
        />
      </InfoBox>

      <InfoBox
        :title="EventState.events[3].getLocalization()"
        :value="eventsGeneralInformation!.numberOfInExecution"
        :backgroundColor="EventState.events[3].lightColor"
        :textColor="EventState.events[3].color"
        :call-back="() => applyFilterState(EventState.events[3])"
      >
        <IconManager
          name="Play"
          :style="{ color: EventState.events[3].color }"
        />
      </InfoBox>

      <InfoBox
        :title="EventState.events[4].getLocalization()"
        :value="eventsGeneralInformation!.numberOfConcluded"
        :backgroundColor="EventState.events[4].lightColor"
        :textColor="EventState.events[4].color"
        :call-back="() => applyFilterState(EventState.events[4])"
      >
        <IconManager
          name="Flag"
          :style="{ color: EventState.events[4].color }"
        />
      </InfoBox>
      <InfoBox
        :title="EventState.events[5].getLocalization()"
        :value="eventsGeneralInformation!.numberOfCanceled"
        :backgroundColor="EventState.events[5].lightColor"
        :textColor="EventState.events[5].color"
        :call-back="() => applyFilterState(EventState.events[5])"
      >
        <IconManager
          name="Cancel"
          :style="{ color: EventState.events[5].color }"
        />
      </InfoBox>
    </div>

    <FilterBox styleInputOptions="md:grid-cols-3">
      <template #inputOptions>
        <CustomInput
          v-model="filterId"
          maxlength="50"
          :title="t('events.list.filter.id')"
          :placeholder="t('events.list.filter.idPlaceholder')"
        >
          <IconManager name="Search" class="text-light-gray" />
        </CustomInput>

        <CustomInput
          v-model="filterName"
          maxlength="50"
          :title="t('events.list.filter.name')"
          :placeholder="t('events.list.filter.namePlaceholder')"
        >
          <IconManager name="Search" class="text-light-gray" />
        </CustomInput>

        <CustomInput
          v-model="filterLocation"
          maxlength="50"
          :title="t('events.list.filter.location')"
          :placeholder="t('events.list.filter.locationPlaceholder')"
        >
          <IconManager name="Search" class="text-light-gray" />
        </CustomInput>

        <CustomDatePicker
          :title="t('events.list.filter.startDate')"
          v-model="filterStartDate"
          :clearable="true"
          :placeholder="t('events.list.filter.startDate')"
        />

        <CustomDatePicker
          :title="t('events.list.filter.endDate')"
          :placeholder="t('events.list.filter.endDate')"
          v-model="filterEndDate"
          :format-locale="pt"
          :clearable="true"
        />
      </template>
      <template #filterStateOptions>
        <FilterState
          v-for="option in eventStates"
          :label="option.getLocalization()"
          :value="option.value"
          :color="option.color"
          v-model="filterState"
        />
      </template>
      <template #filterButtons>
        <div class="flex flex-row sm:w-[35%] sm:ml-auto gap-2">
          <CustomCleanFilterButton
            class="flex-1"
            :title="t('common.filter.cleanFilters')"
            @click="clearFilters"
            :numberActivedFilters="getActiveFiltersCount()"
            :hasActiveFilters="hasActiveFilters()"
          />

          <CustomApplyFilterButton
            class="flex-1"
            :title="t('common.filter.filter')"
            @click="applyFilters"
            :hasUnappliedFilters="hasUnappliedFilters()"
          />
        </div>
      </template>
      <template #filterTagBox>
        <AppliedFilterBox :hasActiveFilters="hasActiveFilters()">
          <template #filterTag>
            <FilterTag
              :title="t('events.list.filter.id')"
              :value="appliedFilters.id"
              :isVisible="filterId"
            />

            <FilterTag
              :title="t('events.list.filter.name')"
              :value="appliedFilters.name"
              :isVisible="filterName"
            />

            <FilterTag
              :title="t('events.list.filter.location')"
              :value="appliedFilters.location"
              :isVisible="filterLocation"
            />

            <FilterTag
              :title="t('events.list.filter.startDate')"
              :value="appliedFilters.startDate"
              :isVisible="filterStartDate"
            />

            <FilterTag
              :title="t('events.list.filter.endDate')"
              :value="appliedFilters.endDate"
              :isVisible="filterEndDate"
            />

            <FilterTag
              :title="t('audit.filter.state')"
              :value="
                appliedFilters.state.map((item) => item.getLocalization())
              "
              :isVisible="filterState.length > 0"
            />
          </template>
        </AppliedFilterBox>
      </template>
    </FilterBox>

    <CustomTable
      :data="events"
      :is-loading="loadingTable"
      :total-entries="tableState.totalEntries"
      :pagination="{ goToPageCallBack: goToPage }"
      :pageSizeOptions="{ changeCallBack: goToPage }"
      :sort-call-back="sortColumn"
      :columns="[
        { key: 'id', title: t('events.list.table.id'), sortable: false },
        { key: 'name', title: t('events.list.table.name'), sortable: true },
        { key: 'type', title: t('events.list.table.type'), sortable: true },
        {
          key: 'startDate',
          title: t('events.list.table.start'),
          sortable: true,
          render: (value: Date) =>
            h(
              'span',
              {
                class: 'flex flex-row items-center gap-2 rounded-xl px-2 w-max',
              },
              value.getDate() +
                ' ' +
                value.toLocaleString('pt-PT', { month: 'short' }),
            ),
        },
        {
          key: 'endDate',
          title: t('events.list.table.end'),
          sortable: true,
          render: (value: Date) =>
            h(
              'span',
              {
                class: 'flex flex-row items-center gap-2 rounded-xl px-2 w-max',
              },
              value.getDate() +
                ' ' +
                value.toLocaleString('pt-PT', { month: 'short' }),
            ),
        },
        {
          key: 'numberOfParticipants',
          title: t('events.list.table.pax'),
          sortable: true,
        },
        {
          key: 'location',
          title: t('events.list.table.local'),
          sortable: true,
        },
        {
          key: 'status',
          title: t('events.list.table.state'),
          sortable: true,
          render: (value: EventState) =>
            h(
              'div',
              {
                class: 'flex flex-row items-center gap-2 rounded-xl px-2 w-max',
                style: { backgroundColor: value.lightColor },
              },
              [
                h('span', {
                  class: 'w-2.5 h-2.5 rounded-full inline-block',
                  style: { backgroundColor: value.color },
                }),
                h(
                  'span',
                  { class: 'font-bold', style: { color: value.color } },
                  value.getLocalization(),
                ),
              ],
            ),
        },
        {
          key: 'actions',
          title: t('events.list.table.actions'),
          sortable: false,
          render: (_, row: EventModel) =>
            h(
              'div',
              {
                class: 'flex flex-row gap-2 items-center justify-center',
              },
              [
                row.status.value != EventState.events[4].value &&
                  row.status.value != EventState.events[5].value &&
                  h(
                    CustomButton,
                    {
                      class: 'text-red-500! bg-red-200! border-none! p-2!',
                      onClick: () => deleteEvent(row.id),
                      tooltip: t('common.cancel'),
                    },
                    () =>
                      h(IconManager, {
                        name: 'Cancel',
                      }),
                  ),
                h(
                  CustomButton,
                  {
                    class: 'bg-secondary! text-primary border-none! p-2!',
                    onClick: () => go(RouteName.EventDetail, { id: row.id }),
                    tooltip: t('common.see'),
                  },
                  () =>
                    h(IconManager, {
                      name: 'Eye',
                    }),
                ),
                row.status.value != EventState.events[4].value &&
                  row.status.value != EventState.events[5].value &&
                  h(
                    CustomButton,
                    {
                      class: 'bg-light-blue! text-blue! border-none! p-2!',
                      onClick: () =>
                        go(RouteName.EventDetailEdit, { id: row.id }),
                      tooltip: t('common.edit'),
                    },
                    () =>
                      h(IconManager, {
                        name: 'Edit',
                      }),
                  ),
              ],
            ),
        },
      ]"
    />
  </div>
</template>

<script setup lang="ts">
import { pt } from "date-fns/locale";
import { useToast } from "@/core/composables/use-toast";
import IconManager from "@/core/IconManager.vue";
import InfoBox from "@/core/components/InfoBox.vue";
import CustomDatePicker from "@/core/components/CustomDatePicker.vue";
import CustomInput from "@/core/components/CustomInput.vue";
import CustomButton from "@/core/components/CustomButton.vue";
import "./EventsPage.scss";
//Filter
import CustomCleanFilterButton from "@/core/components/filter/CustomCleanFilterButton.vue";
import CustomApplyFilterButton from "@/core/components/filter/CustomApplyFilterButton.vue";
import AppliedFilterBox from "@/core/components/filter/AppliedFilterBox.vue";
import FilterBox from "@/core/components/filter/FilterBox.vue";
import FilterState from "@/core/components/filter/FilterState.vue";
import FilterTag from "@/core/components/filter/FilterTag.vue";

//Table
import CustomTable from "@/core/components/table/CustomTable.vue";
import { useI18n } from "vue-i18n";
import { eventsRemoteDataSource } from "@/core/models/global-variables";
import { EventState } from "../models/event-state";
import { h, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { EventModel } from "../models/event-model";
import { EventGeneralInformation } from "../models/event-general-information";
import { RouteName } from "@/core/models/route-name";
import { Utils } from "@/core/models/utils";

const { t, locale } = useI18n();
const { showError, showSuccess } = useToast();

const router = useRouter();
const events = ref<EventModel[]>([]);
const eventsGeneralInformation = ref<EventGeneralInformation | null>(null);
const isLoading = ref<boolean>(true);
const loadingTable = ref<boolean>(false);
const eventStates = EventState.events;
onMounted(() => {
  loadInitialData();
});
//Filter
const filterId = ref<string>("");
const filterName = ref<string>("");
const filterLocation = ref<string>("");
const filterStartDate = ref<Date | null>(null);
const filterEndDate = ref<Date | null>(null);
const filterState = ref<string[]>([]);
const appliedFilters = ref<{
  id: string;
  name: string;
  location: string;
  startDate: string;
  endDate: string;
  state: EventState[];
}>({
  id: "",
  name: "",
  startDate: "",
  endDate: "",
  state: [],
  location: "",
});

//TableState
const tableState = ref<{
  pageSize: number;
  totalEntries: number;
}>({
  pageSize: 10,
  totalEntries: 0,
});

//

function go(name: string, params: Record<string, any> = {}) {
  router.push({
    name,
    params,
  });
}

async function applyFilters() {
  try {
    loadingTable.value = true;
    const response = await eventsRemoteDataSource.getEvents({
      eventId: filterId.value,
      name: filterName.value,
      location: filterLocation.value,
      startDate: filterStartDate.value?.getTime(),
      endDate: filterEndDate.value?.getTime(),
      eventStatus: filterState.value,
      pageNumber: 1,
      pageSize: tableState.value.pageSize,
    });
    if (!response.isSuccess) {
      showError({
        message: response.detail!,
        title: response.title,
        statusCode: response.statusCode,
      });
    }
    appliedFilters.value = {
      id: filterId.value,
      name: filterName.value,
      location: filterLocation.value,
      startDate: filterStartDate.value
        ? Utils.formatDate(filterStartDate.value!, locale.value)
        : "",
      endDate: filterEndDate.value
        ? Utils.formatDate(filterEndDate.value!, locale.value)
        : "",
      state: filterState.value.map((item) =>
        EventState.getEventStateByValue(item),
      ),
    };
    tableState.value.totalEntries = response.data.totalItems;
    events.value = response.data.items;
  } catch (error: any) {
    showError({ title: error });
  } finally {
    loadingTable.value = false;
  }
}

async function clearFilters() {
  loadingTable.value = true;

  try {
    const response = await eventsRemoteDataSource.getEvents({
      pageNumber: 1,
      pageSize: tableState.value.pageSize,
    });
    if (!response.isSuccess) {
      showError({
        message: response.detail!,
        title: response.title,
        statusCode: response.statusCode,
      });
    }
    tableState.value.totalEntries = response.data.totalItems;
    events.value = response.data.items;
    appliedFilters.value = {
      id: "",
      name: "",
      location: "",
      startDate: "",
      endDate: "",
      state: [],
    };

    filterId.value = "";
    filterName.value = "";
    filterLocation.value = "";
    filterStartDate.value = null;
    filterEndDate.value = null;
    filterState.value = [];
  } catch (error: any) {
    showError({ title: error });
  } finally {
    loadingTable.value = false;
  }
}

function hasActiveFilters(): boolean {
  return (
    appliedFilters.value.id.length > 0 ||
    appliedFilters.value.name.length > 0 ||
    appliedFilters.value.location.length > 0 ||
    appliedFilters.value.startDate.length > 0 ||
    appliedFilters.value.endDate.length > 0 ||
    appliedFilters.value.state.length > 0
  );
}

function hasUnappliedFilters(): boolean {
  const fieldsChanged =
    appliedFilters.value.id !== filterId.value ||
    appliedFilters.value.name !== filterName.value ||
    appliedFilters.value.location !== filterLocation.value ||
    appliedFilters.value.startDate !==
      (filterStartDate.value
        ? Utils.formatDate(filterStartDate.value!, locale.value)
        : "") ||
    appliedFilters.value.endDate !==
      (filterEndDate.value
        ? Utils.formatDate(filterEndDate.value!, locale.value)
        : "");

  const stateChanged = !arraysEqualUnordered(
    filterState.value,
    appliedFilters.value.state.map((item) => item.value),
  );

  return fieldsChanged || stateChanged;
}

function arraysEqualUnordered(a: string[], b: string[]): boolean {
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((val, index) => val === sortedB[index]);
}

function getActiveFiltersCount(): number {
  return Object.values(appliedFilters.value).filter((value) => value.length > 0)
    .length;
}

async function applyFilterState(value: EventState) {
  try {
    const response = await eventsRemoteDataSource.getEvents({
      pageNumber: 1,
      pageSize: tableState.value.pageSize,
      eventStatus: [value.value],
    });
    if (!response.isSuccess) {
      showError({
        message: response.detail!,
        title: response.title,
        statusCode: response.statusCode,
      });
    }
    tableState.value.totalEntries = response.data.totalItems;
    events.value = response.data.items;
    appliedFilters.value = {
      id: "",
      name: "",
      location: "",
      startDate: "",
      endDate: "",
      state: [value],
    };

    filterId.value = "";
    filterName.value = "";
    filterLocation.value = "";
    filterStartDate.value = null;
    filterEndDate.value = null;
    filterState.value = [value.value];
  } catch (error: any) {
    showError({ title: error });
  } finally {
    loadingTable.value = false;
  }
}

async function loadInitialData() {
  isLoading.value = true;

  try {
    const [eventsRes, generalInformationRes] = await Promise.all([
      eventsRemoteDataSource.getEvents(),
      eventsRemoteDataSource.getGeneralInformation({}),
    ]);
    if (!eventsRes.isSuccess) {
      showError({
        message: eventsRes.detail!,
        title: eventsRes.title,
        statusCode: eventsRes.statusCode,
      });
    }
    events.value = eventsRes.data.items;
    tableState.value.totalEntries = eventsRes.data.totalItems;

    if (!generalInformationRes.isSuccess) {
      showError({
        message: generalInformationRes.detail!,
        title: generalInformationRes.title,
        statusCode: generalInformationRes.statusCode,
      });
    }
    eventsGeneralInformation.value = generalInformationRes.data;
  } catch (error: any) {
    showError({ title: error });
  } finally {
    isLoading.value = false;
  }
}

async function goToPage(page: number, pageSize: number) {
  isLoading.value = true;

  try {
    const response = await eventsRemoteDataSource.getEvents({
      eventId: filterId.value,
      name: filterName.value,
      location: filterLocation.value,
      startDate: filterStartDate.value?.getTime(),
      endDate: filterEndDate.value?.getTime(),
      eventStatus: filterState.value,
      pageNumber: page,
      pageSize: pageSize,
    });
    if (!response.isSuccess) {
      showError({
        message: response.detail!,
        title: response.title,
        statusCode: response.statusCode,
      });
    }
    tableState.value.pageSize = pageSize;
    tableState.value.totalEntries = response.data.totalItems;
    events.value = response.data.items;
  } catch (error: any) {
    showError({ title: error });
  } finally {
    isLoading.value = false;
  }
}

async function sortColumn(
  key: string,
  orderDirection: string,
): Promise<boolean> {
  try {
    loadingTable.value = true;
    const response = await eventsRemoteDataSource.getEvents({
      eventId: filterId.value,
      name: filterName.value,
      location: filterLocation.value,
      startDate: filterStartDate.value?.getTime(),
      endDate: filterEndDate.value?.getTime(),
      eventStatus: filterState.value,
      pageNumber: 1,
      pageSize: tableState.value.pageSize,
      orderBy: key,
      orderDirection: orderDirection,
    });
    if (!response.isSuccess) {
      showError({
        message: response.detail!,
        title: response.title,
        statusCode: response.statusCode,
      });
    }
    tableState.value.totalEntries = response.data.totalItems;
    events.value = response.data.items;
    return true;
  } catch (error: any) {
    showError({ title: error });
    return false;
  } finally {
    loadingTable.value = false;
  }
}

async function deleteEvent(id: string) {
  loadingTable.value = true;

  try {
    const response = await eventsRemoteDataSource.deleteEvent(id);
    if (!response.isSuccess) {
      showError({
        message: response.detail!,
        title: response.title,
        statusCode: response.statusCode,
      });
    } else showSuccess({ title: t("message.deletedSucess") });
    await applyFilters();
  } catch (error: any) {
    showError({ title: error });
  } finally {
    loadingTable.value = false;
  }
}
</script>
